import React, { useState } from "react";
import { Typography } from "@mui/material";
import positionStyles from "./UpdatePosition.module.css";
import UpdatePositionModal from "./UpdatePositionModal";
import {useFetchAllPositions} from "../../../../hooks/authorization/useFetchAllPositions";
import {PositionWithUsersAndRights} from "../../../../types/api/authorization/position.types";
import {positionService} from "../../../../services/authorization/position-service";
import useAppSnackbar from "../../../../hooks/useAppSnackbar";


export const UpdatePosition = () => {
    const {showSuccess, showError, SnackbarComponent} = useAppSnackbar();
    const {
        data: positionsData,
        refetch: positionRefetch
    } = useFetchAllPositions();
    const [selectedPosition, setSelectedPosition] = useState<PositionWithUsersAndRights | null>(null);
    const [searchQuery, setSearchQuery] = useState<string>("");

    const handlePositionClick = (position: PositionWithUsersAndRights) => {
        setSelectedPosition(position);
    };

    const handleCloseModal = () => {
        setSelectedPosition(null);
    };

    const handleSavePosition = async (positionData: any) => {
        console.log("Updating position:", positionData);
        try {
            await positionService.update(positionData);
            showSuccess("Права успешно обновлены");
            positionRefetch();
        }
        catch (e) {
            showError("Обновление прав прошло неуспешно");
        }
        handleCloseModal();
    };

    const filteredPositions = (positionsData ?? []).filter(p => {
        const q = searchQuery.trim().toLowerCase();
        if (!q) return true;
        const title = (p.title ?? "").toLowerCase();
        return title.includes(q);
    });

    return (
        <div className={positionStyles.page}>
            <div className={positionStyles.pageContainer}>
                <div className={positionStyles.headerRow}>
                    <div>
                        <h1 className={positionStyles.pageTitle}>Должности</h1>
                        <p className={positionStyles.pageSubtitle}>Управление должностями компании</p>
                    </div>
                    <div className={positionStyles.headerActions}>
                        <div className={positionStyles.searchInput}>
                            <span className={positionStyles.searchIcon}>🔍</span>
                            <input
                                className={positionStyles.searchField}
                                placeholder="Поиск должности..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className={positionStyles.cardsGrid}>
                    {filteredPositions.map((position) => (
                        <div
                            key={position.id}
                            className={`${positionStyles.card} ${
                                selectedPosition?.id === position.id ? positionStyles.cardSelected : ""
                            }`}
                            onClick={() => handlePositionClick(position)}
                        >
                            <div className={positionStyles.cardHeader}>
                                <Typography className={positionStyles.cardTitle}>
                                    {position.title}
                                </Typography>
                                <button className={positionStyles.cardEditAction} aria-label="Редактировать">
                                    ✎
                                </button>
                            </div>
                            <p className={positionStyles.cardHint}>Нажмите для редактирования</p>
                        </div>
                    ))}
                </div>
            </div>

            {selectedPosition && (
                <UpdatePositionModal
                    position={selectedPosition}
                    onClose={handleCloseModal}
                    onSave={handleSavePosition}
                />
            )}
            <SnackbarComponent/>
        </div>
    );
};

export default UpdatePosition;
